import React from 'react';
interface Props {
  count: number;
  title: string;
  onClick?: () => void;
  clickable?: boolean;
}

const LeadCountCard: React.FC<Props> = ({ count, title, onClick, clickable = false }) => {
  return (
    <div 
      className={`count-card ${clickable ? 'clickable' : ''}`}
      onClick={onClick}
      style={{ cursor: clickable ? 'pointer' : 'default' }}
    >
      <h2>{count}</h2>
      <p>{title}</p>
    </div>
  );
};

export default LeadCountCard;